const isUserAdmin = (userRole) => {
  if (userRole === "ttp_administrator" || userRole === "council_administrator") {
    return true;
  }
  return false;
};
export default isUserAdmin;
